import { useNavigate, useParams } from "react-router-dom";


const Header = ({title=""}) => {
    const navigate = useNavigate();
    const { prescriptionId } = useParams();
    const handleBack = () => {
        navigate(`/e-prescription/${prescriptionId}`);
    };
    return (
        <nav className="sticky top-0 z-50 bg-white px-4 py-3 shadow-sm flex items-center">
            <button
                onClick={handleBack}
                className="text-black px-2 py-2 mr-2"
            >
                <img
                    src="/images/leading-actions.svg"
                    alt="Kembali"
                    className="w-8 h-8"
                />
            </button>
            <h1 className="text-base font-medium">{title}</h1>
        </nav>
    );
};


export default Header;